var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat;

var ModifierDefinition = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    var parts = ['modifier ', node.name];

    if (node.parameters && node.parameters.parameters) {
      // if node.paremeters is an object, print parameter list
      parts.push('(');
      parts = parts.concat(path.call(_print, 'parameters'));
      parts.push(') ');
    } else if (node.parameters && node.parameters.length === 0) {
      // if node.paremeters is an empty array, don't print parentheses
      parts.push(' ');
    } else {
      // otherwise, throw a not implemented error
      throw new Error('[ModifierDefinition] Scenario not implemented');
    }

    parts.push(path.call(_print, 'body'));
    return concat(parts);
  }
};
module.exports = ModifierDefinition;